/**
 * Mapa uczelni (blok zostan-inzynierem/universities-map).
 *
 * Lista uczelni dociągana jest AJAX-em, a Google Maps ładuje się async
 * z callbackiem initUniversitiesMap — inicjalizacja mapy startuje dopiero,
 * gdy obie rzeczy są gotowe (kolejność zakończenia jest dowolna).
 */
(function ($) {
	var markerItems = {};
	var infoWindow = null;
	var map = null;
	var mapsReady = false;
	var dataReady = false;
	var initialized = false;
	var userLocation = null;
	var userMarker = null;
	var directionsRenderer = null;

	window.initUniversitiesMap = function () {
		mapsReady = true;
		tryInit();
	};

	$(function () {
		var $block = $('.universities-map-block');
		if (!$block.length) {
			return;
		}

		// Delegacja: przycisk występuje na liście i w dymkach markerów (dynamiczny HTML).
		$(document).on('click', '.item__distance-btn', function (e) {
			e.preventDefault();
			e.stopPropagation(); // klik w przycisk nie ma przesuwać mapy jak klik w element listy
			calculateDistance($(this));
		});

		$.post(window.ziUniversitiesMap.ajaxUrl, { action: 'zi_universities_map_items' })
			.done(function (res) {
				if (!res || !res.success) {
					showLoadError($block);
					return;
				}
				var $select = $block.find('#shopsCitiesList');
				res.data.cities.forEach(function (city) {
					$select.append($('<option>').attr('value', city).text(city));
				});
				if (res.data.cities.length) {
					$block.find('.shops-map__search').show();
				}
				$block.find('.shops-map__list').html(res.data.html);
				dataReady = true;
				tryInit();
			})
			.fail(function () {
				showLoadError($block);
			});
	});

	function showLoadError($block) {
		$block
			.find('.shops-map__list')
			.html(
				'<div class="universities-map-block__loading">Nie udało się wczytać listy uczelni. Odśwież stronę i spróbuj ponownie.</div>',
			);
	}

	function tryInit() {
		if (!mapsReady || !dataReady || initialized) {
			return;
		}
		initialized = true;
		initMap();
	}

	function hasPosition(item) {
		return $(item).data('locationLat') !== '' && $(item).data('locationLng') !== '';
	}

	/* --- Odległość od lokalizacji użytkownika --- */

	function getUserLocation(onSuccess, onError) {
		if (userLocation) {
			onSuccess(userLocation);
			return;
		}
		if (!navigator.geolocation) {
			onError('Twoja przeglądarka nie obsługuje geolokalizacji.');
			return;
		}
		navigator.geolocation.getCurrentPosition(
			function (pos) {
				userLocation = { lat: pos.coords.latitude, lng: pos.coords.longitude };
				if (map && !userMarker) {
					userMarker = new google.maps.Marker({
						map: map,
						position: userLocation,
						title: 'Twoja lokalizacja',
						zIndex: 9999,
						icon: {
							path: google.maps.SymbolPath.CIRCLE,
							scale: 8,
							fillColor: '#4285F4',
							fillOpacity: 1,
							strokeColor: '#ffffff',
							strokeWeight: 2,
						},
					});
				}
				onSuccess(userLocation);
			},
			function () {
				onError(
					'Nie udało się pobrać lokalizacji — sprawdź zgodę na geolokalizację w przeglądarce.',
				);
			},
			{ enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 },
		);
	}

	function haversineKm(a, b) {
		var R = 6371;
		var toRad = function (deg) {
			return (deg * Math.PI) / 180;
		};
		var dLat = toRad(b.lat - a.lat);
		var dLng = toRad(b.lng - a.lng);
		var s =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(toRad(a.lat)) *
				Math.cos(toRad(b.lat)) *
				Math.sin(dLng / 2) *
				Math.sin(dLng / 2);
		return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
	}

	function setDistanceText(markerId, text, isError) {
		// Aktualizuje wynik na liście i w otwartym dymku markera jednocześnie.
		$('.item__distance[data-marker-id="' + markerId + '"]')
			.text(text)
			.toggleClass('is-error', !!isError);
	}

	function calculateDistance(btn) {
		var markerId = btn.data('markerId');
		var destination = {
			lat: parseFloat(btn.attr('data-lat')),
			lng: parseFloat(btn.attr('data-lng')),
		};
		if (isNaN(destination.lat) || isNaN(destination.lng)) {
			return;
		}
		setDistanceText(markerId, 'Obliczanie…');

		getUserLocation(
			function (origin) {
				new google.maps.DirectionsService().route(
					{
						origin: origin,
						destination: destination,
						travelMode: google.maps.TravelMode.DRIVING,
					},
					function (result, status) {
						if (status === 'OK' && result.routes.length) {
							var leg = result.routes[0].legs[0];
							setDistanceText(
								markerId,
								leg.distance.text + ' • ok. ' + leg.duration.text + ' autem',
							);
							if (!directionsRenderer) {
								directionsRenderer = new google.maps.DirectionsRenderer({
									suppressMarkers: true,
								});
							}
							directionsRenderer.setMap(map);
							directionsRenderer.setDirections(result);
						} else {
							// Directions API niedostępne albo brak trasy — odległość w linii prostej.
							var km = haversineKm(origin, destination);
							setDistanceText(
								markerId,
								km.toFixed(1).replace('.', ',') + ' km w linii prostej',
							);
						}
					},
				);
			},
			function (message) {
				setDistanceText(markerId, message, true);
			},
		);
	}

	function openMarkerInfoWindow(marker, scrollToItem) {
		if (infoWindow) {
			infoWindow.close();
		}

		var markerItem = $(
			'.shops-map__list .item[data-marker-id="' + marker.markerData.markerId + '"]',
		);

		infoWindow = new google.maps.InfoWindow({
			content: '<div class="marker-item">' + markerItem.html() + '</div>',
		});
		infoWindow.open(map, marker);

		if (scrollToItem) {
			$('.shops-map__list').animate(
				{
					scrollTop: markerItem.get(0).offsetTop,
				},
				250,
				function () {
					markerItem.addClass('active');
					setTimeout(function () {
						markerItem.removeClass('active');
					}, 500);
				},
			);
		}
	}

	function resetMarkerSizes() {
		$('.shops-map__list .item').each(function (index, item) {
			if (markerItems[$(item).data('markerId')]) {
				markerItems[$(item).data('markerId')].setIcon({
					url: $(item).data('markerIcon'),
					scaledSize: new google.maps.Size(48, 48),
				});
			}
		});
	}

	function initMap() {
		map = new google.maps.Map(document.querySelector('.shops-map__map > #map'), {
			zoom: 7,
			center: {
				lat: 52.1419523,
				lng: 20.1075401,
			},
			maxZoom: 15,
		});
		google.maps.event.addListener(map, 'click', function () {
			if (infoWindow) {
				infoWindow.close();
			}
		});

		$('.shops-map__list .item').each(function (index, item) {
			if (!hasPosition(item)) {
				return; // wpis bez lokalizacji — widoczny na liście, bez markera
			}
			var marker = new google.maps.Marker({
				map: map,
				animation: google.maps.Animation.DROP,
				position: new google.maps.LatLng({
					lat: $(item).data('locationLat'),
					lng: $(item).data('locationLng'),
				}),
				icon: {
					url: $(item).data('markerIcon'),
					scaledSize: new google.maps.Size(48, 48),
				},
				markerData: $(item).data(),
			});

			marker.addListener('click', function () {
				openMarkerInfoWindow(this, true);
			});

			markerItems[$(item).data('markerId')] = marker;
		});

		$('.shops-map__list .item').on('click', function () {
			var item = $(this);
			var markerId = item.data('markerId');

			if (markerItems[markerId]) {
				markerItems[markerId].setAnimation(null);
				setTimeout(function () {
					map.panTo(
						new google.maps.LatLng({
							lat: item.data('locationLat'),
							lng: item.data('locationLng'),
						}),
					);
					map.setZoom(19);
					markerItems[markerId].setIcon({
						url: item.data('markerIcon'),
						scaledSize: new google.maps.Size(80, 80),
					});
					markerItems[markerId].setAnimation(google.maps.Animation.DROP);

					item.addClass('active');
					setTimeout(function () {
						item.removeClass('active');
					}, 500);

					setTimeout(function () {
						openMarkerInfoWindow(markerItems[markerId], false);
					}, 350);
				}, 20);
			}
		});

		map.addListener('center_changed', function () {
			resetMarkerSizes();
		});

		map.addListener('zoom_changed', function () {
			resetMarkerSizes();
			if (infoWindow) {
				infoWindow.close();
			}
		});

		$('#shopsCitiesList').on('change', function () {
			var currentCity = $(this).val();
			var bounds = new google.maps.LatLngBounds();
			$('.shops-map__list .item').each(function (index, item) {
				if (markerItems[$(item).data('markerId')]) {
					if (currentCity === '' || $(item).data('city') === currentCity) {
						markerItems[$(item).data('markerId')].setMap(map);
						markerItems[$(item).data('markerId')].setAnimation(null);
						markerItems[$(item).data('markerId')].setAnimation(
							google.maps.Animation.DROP,
						);
						bounds.extend(
							new google.maps.LatLng(
								$(item).data('locationLat'),
								$(item).data('locationLng'),
							),
						);
						$(item).show();
					} else {
						markerItems[$(item).data('markerId')].setMap(null);
						$(item).hide();
					}
				}
			});

			map.fitBounds(bounds);
			if (map.getZoom() > 15) {
				map.setZoom(15);
				map.setCenter(bounds.getCenter());
			}
		});
	}
})(jQuery);
